export default __webpack_public_path__ + "static/media/image-diners.8e99826f.svg";